(() => {
  const forms = document.querySelectorAll('[data-sticky-atc-form]');

  forms.forEach((form) => {
    if (form.dataset.stickyAtcReady === 'true') {
      return;
    }

    form.dataset.stickyAtcReady = 'true';

    const button = form.querySelector('[type="submit"]');
    const spinner = form.querySelector('.loading__spinner');
    const errorElement = form.querySelector('[data-sticky-atc-error]');

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') {
        return;
      }

      const cartDrawer = document.querySelector('cart-drawer');

      if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') {
        showError(errorElement, 'Cart drawer is not available.');
        return;
      }

      const formData = new FormData(form);
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      cartDrawer.setActiveElement(document.activeElement);

      setLoading(button, spinner, true);
      showError(errorElement);

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            showError(errorElement, response.description || response.message);
            return;
          }

          cartDrawer.renderContents(response);
          cartDrawer.classList.remove('is-empty');
        })
        .catch(() => {
          showError(errorElement, window.cartStrings?.error || 'Something went wrong. Please try again.');
        })
        .finally(() => {
          setLoading(button, spinner, false);
        });
    });
  });

  function setLoading(button, spinner, isLoading) {
    button.toggleAttribute('aria-disabled', isLoading);
    button.classList.toggle('loading', isLoading);
    spinner?.classList.toggle('hidden', !isLoading);
  }

  function showError(errorElement, message = '') {
    if (!errorElement) {
      return;
    }

    errorElement.textContent = message;
    errorElement.toggleAttribute('hidden', !message);
  }
})();
